<template>
    <div class="news">
        <Header active="news"></Header>

        <el-row class="banner" type="flex" align="middle">
        </el-row>

        <el-row class="navigation" type="flex" align="middle">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/news' }">新闻中心</el-breadcrumb-item>
                <el-breadcrumb-item>{{data.title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </el-row>

        <el-row>
            <h2>{{data.title}}</h2>
            <span class="time">发布时间：{{convertTime(data.createTime)}}</span>
        </el-row>
        <el-row class="news-content" v-html="data.content">

        </el-row>

        <Footer></Footer>
    </div>
</template>

<script>



    import Header from "../components/Header";
    import Footer from "../components/Footer";
    import {newsApi} from "../api/news-api";
    import {formatFromTimeString} from "../utils/date";

    export default {
        name: "NewsDetail",
        components: {Footer, Header},
        props: {
            id: null
        },
        data () {
            return {
                data: {}
            }
        },
        mounted () {
            this.loadData()
        },
        methods: {
            loadData () {
                newsApi.info(this.id).then(res => {
                    if (res.code === 200) {
                        console.log(res);
                        this.data = res.news;
                    }
                })
            }
        },
        computed: {
            convertTime () {
                return function (time) {
                    return formatFromTimeString(time);
                }
            }
        }
    }
</script>

<style scoped>
.news {
    width: 100%;
    height: 100%;
}
.banner {
    height: 300px;
    width: 100%;
    background: url("../assets/imgs/news/job_bg.jpg") no-repeat;
    background-size: 100% 100%;
}
    .news-content {
        padding: 0 15%;
        /*min-height: 600px;*/
        text-align: left;
        margin-bottom: 60px;
    }
    .time {
        font-size: 13px;
        color: gray;
    }

    .navigation {
        min-height: 80px;
        padding: 0 15%;
        box-shadow: 0 2px 0 0 rgba(0,0,0,.05)
    }
</style>
